import React, {useState} from 'react';
import {Button, Modal} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);

const ConfirmationModal = (props) => {
    const [visible, setVisible] = useState(props.showModal === true);

    const onDismiss = () => setVisible(false);

    const localize = () => {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
    };

    localize();

    function confirmAndClose(e) {
        e.preventDefault();
        props.confirmationAction();
        props.toggleModal();
    }

    return (
        <Modal
            className="modal-dialog-centered modal-danger"
            contentClassName="bg-gradient-danger"
            isOpen={visible}
            toggle={props.toggleModal}
        >
            <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                    {/*Your attention is required*/}
                </h6>
                <button
                    aria-label="Close"
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggleModal}
                >
                    <span aria-hidden={true}>×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="py-3 text-center">
                    <i style={{color: "white", fontSize: 50}} className="fas fa-exclamation"/>
                    <h4 className="heading mt-4">{props.alertTitle}</h4>
                    <p>
                        {props.alertBody}
                    </p>
                </div>
            </div>
            <div className="modal-footer">
                <Button
                    className="text-white ml-auto"
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={props.toggleModal}
                >
                    {props.cancelText || alertStrings.no}
                </Button>
                <Button className="btn-white" color="default" type="button"
                        onClick={e => confirmAndClose(e)}>
                    {props.confirmationText || alertStrings.yes}
                </Button>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;